import type { HeroClipQueueConfig } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/shared/preload-queue/types';

export const HERO_CLIP_QUEUE_CONFIG: HeroClipQueueConfig = {
  order: [
    'introMain',
    'speedMain',
    // Straight after Speed's main clip: it takes over seconds after that
    // clip ends, well before Story is reached.
    'speedEndLoop',
    'storyConnection',
    'storyMain',
  ],
};
